module.exports = __webpack_public_path__ + "img/twitterIcon.59e5f51c.svg";